export default __webpack_public_path__ + "static/media/FK.230e516e.svg";